// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';

/**
 * PermissionPill — reusable colored dropdown chip used for both
 * "Access Level" (Admin / Manager / View Only) and
 * "Location Info Access" (Yes / No) columns.
 *
 * Usage:
 *   <PermissionPill
 *     value={user.accessLevel}
 *     options={[
 *       { value: 'Admin', label: 'Admin', variant: 'blue' },
 *       { value: 'Manager', label: 'Manager', variant: 'orange' },
 *       { value: 'View Only', label: 'View Only', variant: 'red' },
 *     ]}
 *     onChange={(next) => updateUser(user.id, 'accessLevel', next)}
 *   />
 */
const CheckIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const XIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

const ICONS = { check: CheckIcon, x: XIcon };

const PermissionPill = ({ value, options, onChange, disabled = false }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const current = options.find(o => o.value === value) || options[0];
    const Icon = current?.icon ? ICONS[current.icon] : null;

    useEffect(() => {
        if (!open) return;
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    return (
        <div className="pp-wrap" ref={ref}>
            <button
                type="button"
                className={`pp-pill pp-pill--${current?.variant || 'blue'}`}
                onClick={() => !disabled && setOpen(p => !p)}
                disabled={disabled}
            >
                {Icon && <Icon />}
                {current?.label}
                {!disabled && (
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" className="pp-pill__chevron">
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                )}
            </button>

            {open && (
                <div className="pp-dropdown">
                    {options.map(opt => {
                        const OptIcon = opt.icon ? ICONS[opt.icon] : null;
                        return (
                            <button
                                key={opt.value}
                                className={`pp-dropdown__item${opt.value === value ? ' pp-dropdown__item--active' : ''}`}
                                onClick={() => { onChange?.(opt.value); setOpen(false); }}
                            >
                                <span className={`pp-dot pp-dot--${opt.variant}`}>{OptIcon && <OptIcon />}</span>
                                {opt.label}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default PermissionPill;